<div class="ft-dropdown goal-types runnerups" [class.open]="open()" (click)="toggle($event)">
    <button class="ft-dropdown-toggle ft-btn ft-btn-outline-dark">{{ incentive()?.['@totalRunnerUps'] }} <i class="ft-icn-caret-down"></i></button>
    <ul class="ft-dropdown-menu">
        @for (number of numbers; track number) {
            <li (click)="setCount(number)"><a>{{ number }}</a></li>
        }
    </ul>
</div>
